import { Switch } from "@mui/material";
import React, { useState } from "react";
import styles from "../Row.module.css";
import { CustomTextField } from "../../../../../../common/components";

const FeatureFlagRow = ({ feature, onSwitchHandler, onDescriptionUpdate }) => {
	const [isEditing, setIsEditing] = useState(false);
	const [editedDescription, setEditedDescription] = useState(feature.description || "");

	const handleSwitchHandler = () => {
		onSwitchHandler(feature);
	};

	const handleDescriptionClick = () => {
		setIsEditing(true);
	};

	const handleDescriptionChange = (e) => {
		setEditedDescription(e.target.value);
	};

	const handleSave = () => {
		setIsEditing(false);
		if (editedDescription !== feature.description) {
			onDescriptionUpdate(feature, editedDescription);
		}
	};

	const handleCancel = () => {
		setIsEditing(false);
		setEditedDescription(feature.description || "");
	};

	const handleKeyDown = (e) => {
		if (e.key === "Enter") {
			handleSave();
		}
		if (e.key === "Escape") {
			handleCancel();
		}
	};

	return (
		<div className={styles.row}>
			<div>{feature.code}</div>
			<div className={styles.descriptionCell}>
				{isEditing ? (
					<CustomTextField
						autoFocus
						fullWidth
						inputProps={{ maxLength: 1000 }}
						placeholder="Add description..."
						size="small"
						value={editedDescription}
						onBlur={handleSave}
						onChange={handleDescriptionChange}
						onKeyDown={handleKeyDown}
					/>
				) : (
					<span
						className={styles.descriptionText}
						role="button"
						tabIndex={0}
						onClick={handleDescriptionClick}
						onKeyDown={handleKeyDown}
					>
						{feature.description || "—"}
					</span>
				)}
			</div>
			<div>
				<Switch checked={feature.active} onClick={handleSwitchHandler} />
			</div>
		</div>
	);
};

export default FeatureFlagRow;
